import { Box, Button } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { creatorDefaultImages, node_server } from "../../../../../constants";
import { useTheme } from "../../../../../context/themeContext";
import { sendProjectSubmissionEmail } from "../../../../../helpers/emails";
import useManageProjects from "../../../../../hooks/useManageProjects";
import {
	setCroppedImage,
	setOriginalProjectImage,
} from "../../../../../store/slices/profile/projectCoverImageSlice";
import { setRoles } from "../../../../../store/slices/profile/rolesSlice";
import AgeRanges from "./components/age-range";
import Basics from "./components/basics";
import Contact from "./components/contact";
import ExprienceLevel from "./components/exprience-level";
import ProjectCoverImage from "./components/project-cover-image";
import RolesList from "./components/roles-list";
import styles from "./style.module.css";

const ProjectForm = ({ setIsOpen }) => {
	const { theme } = useTheme();
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [selectedExprienceLevel, setSelectedExprienceLevel] = useState("All");
	const [title, setTitle] = useState("");
	const [primaryEntity, setPrimaryEntity] = useState("");
	const [description, setDescription] = useState("");
	const [country, setCountry] = useState("");
	const [locationType, setLocationType] = useState("Local");
	const [emailAddress, setEmailAddress] = useState("");
	const dispatch = useDispatch();
	const roles = useSelector((state) => state.roles.value);
	const user = useSelector((state) => state.user.value);
	const { croppedImage, originalProjectImage } = useSelector(
		(state) => state.projectCoverImage,
	);
	const [ageRanges, setAgeRanges] = useState([]);
	const [selectedCreatorTypes, setSelectedCreatorTypes] = useState([]);
	const navigate = useNavigate();
	const { fetchProjects } = useManageProjects();

	const basicProps = {
		title: title,
		setTitle: setTitle,
		primaryEntity,
		setPrimaryEntity,
		description: description,
		setDescription: setDescription,
		country: country,
		setCountry: setCountry,
		selectedCategory,
		setSelectedCategory,
		locationType,
		setLocationType,
	};

	const contactProps = {
		emailAddress: emailAddress,
		setEmailAddress: setEmailAddress,
	};

	const exprienceProps = {
		selectedExprienceLevel,
		setSelectedExprienceLevel,
	};

	const ageRangesProps = {
		ageRanges,
		setAgeRanges,
	};

	const handleSubmitProject = async () => {
		let original = originalProjectImage || null;
		let cropp = croppedImage || null;

		if (
			originalProjectImage === null &&
			selectedCreatorTypes.length !== 0
		) {
			const targetCreatorType = selectedCreatorTypes[0].category;
			const targetImage = creatorDefaultImages[targetCreatorType];
			original = targetImage;
			cropp = targetImage;
		}

		const response = await axios.post(
			`${node_server}/api/projects`,
			{
				title: title,
				user_id: user.id,
				primary_entity: primaryEntity,
				description: description,
				location: country,
				status: "Under Review",
				contact_email: emailAddress,
				submitted_by: user.id,
				created_at: new Date(),
				project_cover_image: cropp,
				original_cover_image: original,
				category: selectedCategory,
				location_type: locationType,
				location_name: country,
				experience_level: selectedExprienceLevel,
			},
			{
				withCredentials: true,
			},
		);
		const error = response.status !== 201 ? response.data : null;
		const data = response.statusText === "Created" ? response.data : null;

		console.log({ response });
		let project;
		if (!response.data) console.log(error);
		if (data) project = data;

		if (error) return; //TODO: show feedback to the user

		await roles.map(async (item) => {
			const record = {
				project_id: project.id,
				category: item.selectedCategory.category,
				creator_skill: item.selectedSkill.skill,
				speciality: item.selectedSpecialty.speciality,
			};

			const { error: projectsRoles } = await axios.post(
				`${node_server}/api/projects/roles`,
				record,
				{
					withCredentials: true,
				},
			);

			if (projectsRoles) console.log(projectsRoles);
		});

		const { error: projectsAgeRanges } = await axios.post(
			`${node_server}/api/projects/age-ranges`,
			{
				projectId: project.id,
				ageRanges: ageRanges,
			},
			{ withCredentials: true },
		);

		if (projectsAgeRanges) console.log(projectsAgeRanges);

		dispatch(
			setRoles([
				{
					num: 1,
					selectedCategory: "",
					selectedSkill: "",
					selectedSpecialty: "",
				},
			]),
		);
		await sendProjectSubmissionEmail(user.id, project.id);
		await setIsOpen(true);
		fetchProjects();
		dispatch(
			setCroppedImage(
				"https://test-assets.collab-with-lynx.com/project-cover-image-0.48025884403475594-v-1710946773530",
			),
		);
		dispatch(setOriginalProjectImage(null));
	};

	const handleCancel = () => {
		dispatch(
			setCroppedImage(
				"https://test-assets.collab-with-lynx.com/project-cover-image-0.48025884403475594-v-1710946773530",
			),
		);
		dispatch(setOriginalProjectImage(null));
		navigate("/projects");
	};

	return (
		<Box component="form" className={styles.projectForm}>
			<ProjectCoverImage />
			<Basics {...basicProps} />
			<RolesList />
			<AgeRanges {...ageRangesProps} />
			<ExprienceLevel {...exprienceProps} />
			<Contact {...contactProps} />
			<Box className={styles.button}>
				<Button
					variant="contained"
					onClick={handleSubmitProject}
					fullWidth
				>
					submit
				</Button>
				<Button
					onClick={handleCancel}
					variant="text"
					fullWidth
					sx={{
						color: theme.palette.darkgrey.darkgrey400,
						textTransform: "capitalize",
						fontSize: "16px",
						fontWeight: "500",
						p: "0px",
					}}
				>
					Cancel
				</Button>
			</Box>
		</Box>
	);
};

export default ProjectForm;
